export const comments_5618946 = {"data":{"data":[],"links":{}}}